import { render, staticRenderFns } from "./input-select.vue?vue&type=template&id=f3189ff0&"
import script from "./input-select.vue?vue&type=script&lang=js&"
export * from "./input-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports